// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* OMIC India Website Styles */

/* Hero Section */
.hero-gradient {
    background: linear-gradient(135deg, rgba(10, 37, 64, 0.95) 0%, rgba(10, 37, 64, 0.7) 50%, transparent 100%);
}

/* Service Cards */
.service-card {
    transition: all 0.3s ease;
}

.service-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 20px 40px rgba(10, 37, 64, 0.15);
}

/* Glassmorphism */
.glass {
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
}

.glass-dark {
    background: rgba(10, 37, 64, 0.9);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
}

/* Stats Counter */
.stat-number {
    font-family: 'Outfit', sans-serif;
    font-weight: 900;
    letter-spacing: -0.02em;
}

/* Navigation */
.nav-link {
    position: relative;
}

.nav-link::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background: #0066FF;
    transition: width 0.3s ease;
}

.nav-link:hover::after {
    width: 100%;
}

/* Section Backgrounds */
.section-dark {
    background: linear-gradient(180deg, #0A2540 0%, #0d2d4d 100%);
}

/* Marquee */
.marquee-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 2rem;
}

/* Form Inputs */
.form-input {
    transition: all 0.2s ease;
}

.form-input:focus {
    border-color: #0066FF;
    box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);
}

/* Button Styles */
.btn-primary {
    background: #0066FF;
    color: white;
    transition: all 0.3s ease;
}

.btn-primary:hover {
    background: #0052CC;
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(0, 102, 255, 0.3);
}

/* Bento Grid */
.bento-grid {
    display: grid;
    gap: 1.5rem;
}

@media (min-width: 768px) {
    .bento-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (min-width: 1024px) {
    .bento-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

/* Office Cards */
.office-card {
    transition: all 0.3s ease;
    border: 1px solid #E2E8F0;
}

.office-card:hover {
    border-color: #0066FF;
    box-shadow: 0 10px 30px rgba(0, 102, 255, 0.1);
}

/* Responsive Typography */
.text-display {
    font-size: clamp(2.5rem, 6vw, 4.5rem);
    line-height: 1.1;
    letter-spacing: -0.02em;
}

.text-heading {
    font-size: clamp(1.75rem, 4vw, 2.5rem);
    line-height: 1.2;
    letter-spacing: -0.01em;
}

/* Image Overlays */
.image-overlay {
    position: relative;
}

.image-overlay::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(10, 37, 64, 0.8) 0%, transparent 60%);
}

/* Accreditation Badges */
.accreditation-badge {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 1.5rem;
    background: white;
    border-radius: 0.75rem;
    border: 1px solid #E2E8F0;
    transition: all 0.3s ease;
}

.accreditation-badge:hover {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B,iBAAiB;AACjB;IACI,2GAA2G;AAC/G;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA,kBAAkB;AAClB;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA,kBAAkB;AAClB;IACI,iCAAiC;IACjC,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,eAAe;AACf;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,6DAA6D;AACjE;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA,eAAe;AACf;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA,0BAA0B;AAC1B;IACI,qCAAqC;IACrC,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,8EAA8E;AAClF;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;AAC7C","sourcesContent":["/* OMIC India Website Styles */\n\n/* Hero Section */\n.hero-gradient {\n    background: linear-gradient(135deg, rgba(10, 37, 64, 0.95) 0%, rgba(10, 37, 64, 0.7) 50%, transparent 100%);\n}\n\n/* Service Cards */\n.service-card {\n    transition: all 0.3s ease;\n}\n\n.service-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 20px 40px rgba(10, 37, 64, 0.15);\n}\n\n/* Glassmorphism */\n.glass {\n    background: rgba(255, 255, 255, 0.9);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n}\n\n.glass-dark {\n    background: rgba(10, 37, 64, 0.9);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n}\n\n/* Stats Counter */\n.stat-number {\n    font-family: 'Outfit', sans-serif;\n    font-weight: 900;\n    letter-spacing: -0.02em;\n}\n\n/* Navigation */\n.nav-link {\n    position: relative;\n}\n\n.nav-link::after {\n    content: '';\n    position: absolute;\n    bottom: -2px;\n    left: 0;\n    width: 0;\n    height: 2px;\n    background: #0066FF;\n    transition: width 0.3s ease;\n}\n\n.nav-link:hover::after {\n    width: 100%;\n}\n\n/* Section Backgrounds */\n.section-dark {\n    background: linear-gradient(180deg, #0A2540 0%, #0d2d4d 100%);\n}\n\n/* Marquee */\n.marquee-item {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 2rem;\n}\n\n/* Form Inputs */\n.form-input {\n    transition: all 0.2s ease;\n}\n\n.form-input:focus {\n    border-color: #0066FF;\n    box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);\n}\n\n/* Button Styles */\n.btn-primary {\n    background: #0066FF;\n    color: white;\n    transition: all 0.3s ease;\n}\n\n.btn-primary:hover {\n    background: #0052CC;\n    transform: translateY(-2px);\n    box-shadow: 0 10px 30px rgba(0, 102, 255, 0.3);\n}\n\n/* Bento Grid */\n.bento-grid {\n    display: grid;\n    gap: 1.5rem;\n}\n\n@media (min-width: 768px) {\n    .bento-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (min-width: 1024px) {\n    .bento-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n/* Office Cards */\n.office-card {\n    transition: all 0.3s ease;\n    border: 1px solid #E2E8F0;\n}\n\n.office-card:hover {\n    border-color: #0066FF;\n    box-shadow: 0 10px 30px rgba(0, 102, 255, 0.1);\n}\n\n/* Responsive Typography */\n.text-display {\n    font-size: clamp(2.5rem, 6vw, 4.5rem);\n    line-height: 1.1;\n    letter-spacing: -0.02em;\n}\n\n.text-heading {\n    font-size: clamp(1.75rem, 4vw, 2.5rem);\n    line-height: 1.2;\n    letter-spacing: -0.01em;\n}\n\n/* Image Overlays */\n.image-overlay {\n    position: relative;\n}\n\n.image-overlay::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(to top, rgba(10, 37, 64, 0.8) 0%, transparent 60%);\n}\n\n/* Accreditation Badges */\n.accreditation-badge {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 1rem 1.5rem;\n    background: white;\n    border-radius: 0.75rem;\n    border: 1px solid #E2E8F0;\n    transition: all 0.3s ease;\n}\n\n.accreditation-badge:hover {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
